"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _math = require("../math.js");

var _default = {
  draw(context, size) {
    const r = (0, _math.sqrt)(size) * 0.62625;
    context.moveTo(0, -r);
    context.lineTo(r, 0);
    context.lineTo(0, r);
    context.lineTo(-r, 0);
    context.closePath();
  }

};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-shape/src/symbol/diamond2.js
// module id = 600
// module chunks = 0